import Select, { SingleValue } from "react-select";
import { useSnapshot } from "valtio";
import { clientDashboardEvents, TreeNode } from "../clientDashboardEvents";
import { campaignLabel, treeForStatus } from "../campaignDates";

type Option = { label: string; value: number | null };

const ALL_OPTION: Option = { label: "All Campaigns", value: null };

export default function LaunchSelect() {
    const snap = useSnapshot(clientDashboardEvents);
    const tree = treeForStatus(snap.filterTree as TreeNode[], snap.status);

    if (!snap.engagement || !snap.objective) return null;

    const engagement = tree.find((e) => e.id === snap.engagement);
    const objective = engagement?.children.find((o) => o.id === snap.objective);
    if (!objective || !objective.children.length) return null;

    const options: Option[] = [
        ALL_OPTION,
        ...objective.children.map((l) => ({ label: campaignLabel(l), value: l.id })),
    ];
    const selected = options.find((o) => o.value === snap.launch) ?? ALL_OPTION;

    return (
        <div className="dash-filter">
            <Select<Option, false>
                options={options}
                value={selected}
                onChange={(opt: SingleValue<Option>) => {
                    clientDashboardEvents.triggerLaunchChanged(opt?.value ?? null);
                }}
                menuPlacement="bottom"
                isClearable={false}
            />
        </div>
    );
}
